module.exports = __webpack_public_path__ + "assets/img/37_1533_big.2ca542ba.jpg";